'use strict'

var navigator = require('global/window').navigator

module.exports = (function detect_iOS (userAgent) {
  return /iPad|iPhone|iPod/.test(userAgent)
})(navigator ? navigator.userAgent : '')



//////////////////
// WEBPACK FOOTER
// ./~/is-ios/index.js
// module id = 505
// module chunks = 1474